import projectsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  query: createAsyncRequestReducer(projectsActionTypes.FETCH_PROJECTS_LIST),
  create: createAsyncRequestReducer(projectsActionTypes.CREATE_PROJECTS_LIST),
  update: createAsyncRequestReducer(projectsActionTypes.UPDATE_PROJECT),
  delete: createAsyncRequestReducer(projectsActionTypes.DELETE_PROJECT),
  patientCount: createAsyncRequestReducer(
    projectsActionTypes.FETCH_PATIENT_COUNT,
  ),
};

export default combineReducers(reducers);
